import styled, { keyframes } from 'styled-components'

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
`

const TimerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const TimerDisplay = styled.div<{ baseColor?: string, isWarning: boolean }>`
  font-size: 2.5rem;
  font-weight: bold;
  font-family: monospace;
  color: ${props => props.isWarning ? '#ff0000' : '#000'};
  padding: 1rem;
  animation: ${pulse} 2s infinite ease-in-out;
  border-radius: 0.5rem;
`

interface CountdownTimerProps {
  time: string;
  baseColor?: string;
}

const CountdownTimer = ({ time, baseColor }: CountdownTimerProps) => {
  const getSeconds = (time: string) => {
    const [minutes, seconds] = time.split(':').map(Number)
    return minutes * 60 + seconds
  }

  const totalSeconds = getSeconds(time)
  const isWarning = totalSeconds <= 10

  return (
    <TimerContainer>
      <TimerDisplay baseColor={baseColor} isWarning={isWarning}>
        {time}
      </TimerDisplay>
    </TimerContainer>
  )
}

export default CountdownTimer
